/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getFile, showModal } from "actions";
import GuidebarModalBody, {
  GuidebarModalTitle,
} from "components/header/GuidebarModal";
import { Trans } from "react-i18next";

class GuideCard extends Component {
  state = {
    fileFetched: false,
    file: null,
    error: null,
  };

  componentDidMount = () => {
    if (this.props.contact.imagePath) {
      this.props.getFile(
        this.props.contact.imagePath,
        this.onBegin,
        this.onSuccess,
        this.onError
      );
    }
    window.addEventListener("scroll", this.handleScroll);

  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }


  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    this.setState({ error: err.message });
    this.props.onProcessEnd();
  };

  onSuccess = (file) => {
    this.props.onProcessEnd();
    this.setState({
      fileFetched: true,
      file: file,
    });
  };

  showDetail = (contact) => {
    this.props.showModal({
      modalType: "GuideDetail",
      modalTitle: <GuidebarModalTitle />,
      modalContent: <GuidebarModalBody id={contact.id} />,
      modalFooter: null,
      modalElementId: "guideModal",
    });
  };

  stopBubbleUp = (e) => {
    e.stopPropagation();
  };

  renderImage = () => {
    return (
      this.props.contact.isOtosanContact ?
        <div
          className="fordOrgCardProfilImg"
          style={{
            "width": "110px",
            backgroundImage: `url(${this.state.file
              ? this.state.file.binary
              : "img/fordotosan-icon.jpg"
              })`,
          }}
        ></div> : <div
          className="fordOrgCardProfilImg"
          style={{
            "width": "110px",
            backgroundImage: `url(${this.state.file
              ? this.state.file.binary
              : "img/ford-gelisim-akademisi-avatar.svg"
              })`,
          }}
        ></div>
    );
  };

  renderEmail = () => {
    if (!this.props.contact.email) return null;
    return (
      <a
        href={`mailto:${this.props.contact.email}`}
        onClick={(e) => this.stopBubbleUp(e)} style={{ textAlign: "right", textDecoration: "none", fontWeight: "bold", color: "#7372d3" }}
      >
        <span ></span> {this.props.contact.email}
      </a>
    );
  };

  renderCompanyPhone = () => {
    if (!this.props.contact.companyPhone) return null;
    return (

      <a
        href={`tel:${this.props.contact.companyPhone}`}
        onClick={(e) => this.stopBubbleUp(e)} style={{ textDecoration: "none", fontWeight: "bold", color: "#7372d3" }}
      >
        <span  ></span>{" "}
        {this.props.contact.companyPhone}
      </a>

    );
  };

  capitalizeEachWord(text) {
    if (!text) return "";

    return text
      .split(" ")
      .map((word) =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  }


  constructor(props) {
    super(props);
    this.state = {
      translateY: 0,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const scrollY = window.scrollY;
    const start = 100;
    const end = 200;

    if (scrollY <= start) {
      this.setState({ translateY: 0 });
    } else if (scrollY > start && scrollY < end) {
      this.setState({ translateY: scrollY - start });
    } else {
      this.setState({ translateY: -200 });
    }
  }

  render() {

    return (
      <div>






        <div
          // className="fordGuideCardInner"
          // className="card boxPlatin"
          // onClick={() => this.showDetail(this.props.contact)}
          style={this.props.isManager ? { backgroundColor: "rgb(237 241 243)" } : null}
        >






          <div style={{
            position: "fixed",
            color: "white",
            textAlign: "center",
            zIndex: 1000,
            transform: `translateY(${this.state.translateY}px)`,
            transition: "transform 0.1s linear",
            width: "55%"
          }}>
            <div className="row gutters-sm">
              <div className="col-md-4 mb-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column align-items-center text-center">
                      {this.renderImage()}
                      <div className="mt-3">
                        <h4>{this.capitalizeEachWord(this.props.contact.fullname)}</h4>
                        <p className="text-secondary mb-1">{this.capitalizeEachWord(this.props.contact.position)}</p>
                        <p className="text-muted font-size-sm">{this.capitalizeEachWord(this.props.contact.department)}</p>

                      </div>
                    </div>
                  </div>
                  <div className="card-footer text-center">
                    {this.props.contact.unit}
                  </div>
                </div>
              </div>
              <div className="col-md-8">
                <div className="card mb-3">
                  <div className="card-body">
                    <ul className="list-group list-group-flush" style={{ color: "#2d96cd" }}>


                      {
                        this.props.contact.email ? <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                          <h6 className="mb-0" >
                            <span className="iconmford fo-icon-email" style={{ fontSize: "20px", verticalAlign: "bottom" }}></span>
                            <Trans desc="E-Posta Adresi">10560</Trans></h6>
                          <span className="text-secondary"  >


                            <a
                              href={`mailto:${this.props.contact.email}`} className="texteffectguide"
                              onClick={(e) => this.stopBubbleUp(e)} style={{ textAlign: "right", textDecoration: "none", fontWeight: "bold" }}
                            >
                              <span ></span> {this.props.contact.email}
                            </a>


                          </span>
                        </li> : null
                      }



                      {
                        this.props.contact.companyPhone ? <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap" style={{ display: this.props.contact.companyPhone ? "block" : "none" }}>
                          <h6 className="mb-0" >

                            <span className="iconmford fo-icon-perm-phone-msg" style={{ verticalAlign: "bottom", fontWeight: "bold", color: "#2d96cd" }}></span>
                            <Trans desc="Telefon No">10562</Trans></h6>
                          <span className="text-secondary">


                            <a
                              href={`tel:${this.props.contact.companyPhone}`} className="texteffectguide"
                              onClick={(e) => this.stopBubbleUp(e)} style={{ textDecoration: "none", fontWeight: "bold", }}
                            >
                              <span  ></span>{" "}
                              {this.props.contact.companyPhone}
                            </a>


                          </span>
                        </li> : null
                      }



                      {
                        this.props.contact.companyPhoneExtension ?
                          <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                            <h6 className="mb-0"  >
                              <span className="iconmford fo-icon-perm-phone-msg" style={{ fontSize: "20px", verticalAlign: "bottom" }}></span>
                              <Trans desc="Dahili Hat">10563</Trans></h6>
                            <span style={{ textDecoration: "none", color: "#2d96cd" }}>{this.props.contact.companyPhoneExtension}</span>
                          </li> : null
                      }



                      {
                        this.props.contact.reportManager ?
                          <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                            <h6 className="mb-0"  >
                              <span className="iconmford fo-icon-account-circle" style={{ fontSize: "20px", verticalAlign: "bottom" }}></span>
                              <Trans desc="Dahili Hat">managerguid</Trans>  </h6>
                            <span style={{ textDecoration: "none", color: "#2d96cd" }}>{this.props.contact.reportManager.name}</span>
                          </li> : null
                      }



                      {
                        this.props.contact.reportManagerMail ? <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                          <h6 className="mb-0" >
                            <span className="iconmford fo-icon-email" style={{ fontSize: "20px", verticalAlign: "bottom" }}></span>
                            <Trans desc="managerguidmail">managerguidmail</Trans></h6>
                          <span className="text-secondary"  >


                            <a
                              href={`mailto:${this.props.contact.reportManagerMail}`} className="texteffectguide"
                              onClick={(e) => this.stopBubbleUp(e)} style={{ textAlign: "right", textDecoration: "none", fontWeight: "bold" }}
                            >
                              <span ></span> {this.props.contact.reportManagerMail}
                            </a>


                          </span>
                        </li> : null
                      }





                    </ul>



                  </div>
                </div>

              </div>
            </div>

          </div>








          {/* <div className="fordOrgCardDownMenu">
            <a href="#" data-toggle="modal" data-target="#rehberDetayModal">
              <div
                className="tooltipTakvim"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Detay Gör"
              >
                <span className="icon-icon-table-dropdown"></span>
              </div>
            </a>
          </div> */}


          {/* <div className="card-header">
            {this.capitalizeEachWord(this.props.contact.fullname)}
          </div>
          <div className="card-body" style={{ marginBottom: "0px", padding: "8px" }}>

            <div style={{ "display": "grid", "grid-template-columns": "1fr 1fr", "justify-items": "stretch" }}>
            <div >

              <div style={{ width: "110px", "display": "inline-block", "float": "left" }}>
                {this.renderImage()}
              </div>
              <div style={{ textAlign: "center", paddingTop: "13px" }}>
                <h5 className="card-title name">{this.capitalizeEachWord(this.props.contact.position)}</h5>
                <p className="card-text dept">{this.capitalizeEachWord(this.props.contact.department)}</p>
              </div>
            </div>
          </div>
          <div className="card-footer text-muted" style={{ "display": "grid", "gridTemplateColumns": "1fr 1fr", justifyItems: "stretch" }}>
            {this.renderCompanyPhone()}  {this.renderEmail()}
          </div> */}



        </div>
      </div>
    );
  }
}

export default connect(null, { getFile, showModal })(
  containsLongRunningProcess(GuideCard)
);
